import { TENANTS } from '../constants';
import { getTenantName, renderAsMarkdown } from '../helpers';
import { MAMessageRenderer } from '../messageassist/maMessageRenderer';

export interface MessageRenderer {
    render(template: string): string;
}

class ComposeMessageRenderer implements MessageRenderer {
    _renderers: MessageRenderer[];

    constructor() {
        this._renderers = [];

        if (getTenantName() == TENANTS.MESSAGE_ASSIST) {
            this._renderers.push(new MAMessageRenderer());
        }

        this._renderers.push(new MarkdownMessageRenderer());
    }

    render(template: string): string {
        let text = template;

        this._renderers.forEach((renderer) => {
            text = renderer.render(text);
        });

        return text;
    }
}

class MarkdownMessageRenderer implements MessageRenderer {
    render(template: string): string {
        return renderAsMarkdown(template);
    }
}

export const getMessageRenderer = (): MessageRenderer => {
    return new ComposeMessageRenderer();
};
